<template>
  <div class="exam-detail">
    <div
      v-if="!loading"
      v-observe-visibility="visibilityChanged"
    />
    <div
      v-if="loading"
      class="exam-detail__loading"
    >
      <spinner />
    </div>
    <div :style="{ display: loading ? 'none' : 'block' }">
      <div class="exam-detail__fixed">
        <div class="exam-detail__top">
          <bread-crumbs :exam-name="exam.name" />
          <exam-search
            :results="true"
            :title="false"
            :btn-search="false"
          />
        </div>
        <div class="exam-detail__wrapper">
          <div class="exam-detail__spacer" />
          <div class="exam-detail__content">
            <!-- title area -->
            <div class="exam-detail__title exam-detail__section">
              <div class="site-header__logo_pdf">
                <a href="https://alvaroapoio.com.br/">
                  <img
                    src="/static/images/logo-site.png"
                    alt="Logo"
                  />
                </a>
              </div>
              <div class="exam-detail__main-title">
                <a
                  href="javascript:history.go(-1)"
                  class="exam-detail__return"
                >
                  <img
                    src="/static/images/site/icon-return.svg"
                    alt="voltar"
                  />
                </a>
                <h1>{{ exam.name }}</h1>
                <p
                  v-if="exam.examConfig && exam.examConfig.listedFor === 'SPECIAL'"
                  class="exam-detail__alert"
                >
                  <img
                    src="/static/images/site/icon-alert.svg"
                    alt="icone"
                  />
                  Para envio desse exame, favor falar com o seu consultor de vendas
                </p>
              </div>
              <div class="exam-detail__title-tags">
                <div class="exam-detail__tag-wrapper">
                  <h4>Mnemônico:</h4>
                  <div
                    v-if="exam.code"
                    class="exam-detail__tag"
                  >
                    {{ exam.code }}
                  </div>
                </div>
                <div
                  v-if="exam.codeSUS"
                  class="exam-detail__tag-wrapper"
                >
                  <h4>SUS:</h4>
                  <div class="exam-detail__tag">
                    {{ exam.codeSUS }}
                  </div>
                </div>
                <div
                  v-if="exam.codeCBHPM"
                  class="exam-detail__tag-wrapper"
                >
                  <h4>CBHPM:</h4>
                  <div class="exam-detail__tag">
                    {{ exam.codeCBHPM }}
                  </div>
                </div>
              </div>
              <div
                v-if="exam.synonym"
                class="exam-detail__synonyms"
              >
                <h4>Sinônimos:</h4>

                <div
                  v-if="!showMoreSynonym && exam.synonym.length > 250"
                  class="exam-detail__card-content"
                >
                  <div v-html="handleSynomym(exam.synonym)" />
                </div>

                <div
                  v-else
                  class="exam-detail__card-content"
                >
                  <div v-html="formatText(exam.synonym)" />
                </div>

                <div
                  v-if="exam.synonym.length > 250"
                  class="exam-detail__toggle"
                  @click="showMoreSynonym = !showMoreSynonym"
                >
                  {{ showMoreSynonym ? 'Ver menos' : 'Ver mais' }}
                  <img
                    :class="{
                      'exam-detail__arrow-down': !showMoreSynonym,
                      'exam-detail__arrow-up': showMoreSynonym,
                    }"
                    src="/static/images/site/icon-drop-down.svg"
                    alt="seta"
                  />
                </div>
              </div>

              <div
                v-else
                class="exam-detail__synonyms"
              >
                <h4>Sem sinônimos</h4>
              </div>
            </div>
            <!-- end title area -->
            <!-- navigation area -->
            <div
              ref="anchorsList"
              class="exam-detail__nav"
            >
              <div
                id="exam"
                class="exam-detail__nav-link exam-detail__nav-link--active"
                href="#top"
                @click="handleNavActive($event, 'producao')"
              >
                Exame
              </div>
              <div
                id="production"
                class="exam-detail__nav-link"
                @click="handleNavActive($event, 'producao')"
              >
                Produção
              </div>
              <div
                id="exam-time"
                class="exam-detail__nav-link"
                @click="handleNavActive($event, 'executionTime')"
              >
                Prazo de execução
              </div>
              <div
                v-if="showInstructions"
                id="instructions"
                class="exam-detail__nav-link"
                @click="handleNavActive($event, 'instrucoes')"
              >
                Instruções
              </div>
              <div
                v-if="validInterpretation"
                id="interpretation"
                class="exam-detail__nav-link"
                @click="handleNavActive($event, 'interpretacao')"
              >
                Interpretação
              </div>
              <div
                id="integration"
                class="exam-detail__nav-link"
                @click="handleNavActive($event, 'integracao')"
              >
                Integração
              </div>
              <div
                v-if="exam.codeRelatedExams && exam.codeRelatedExams.length"
                id="related"
                class="exam-detail__nav-link"
                @click="handleNavActive($event, 'relacionados')"
              >
                Relacionados
              </div>
            </div>
            <!-- end navigation area -->
          </div>
          <div class="exam-detail__actions">
            <button
              class="exam-detail__actions__btn_export_pdf"
              @click="downloadPDF()"
            >
              <svg-loader
                class="icon_exportPDF"
                src="/static/images/site/icon-download-pdf.svg"
              />
              Exportar Pagina em PDF
            </button>

            <template v-if="profile">
              <button
                v-if="
                  shouldBeUsedNewLayout && !showLegacyFormat && !toggle.rollbacklaudasa
                "
                class="btn-primary btn-icon btn-mask"
                aria-label="Máscara de Laudo disponível com a versão no campo Metodologia/Valor de Referência"
                @click="openExamMaskInfoModal"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="left"
                >
                  Máscara de Laudo disponível com a versão no campo Metodologia/Valor de
                  Referência
                </md-tooltip>
                <md-icon
                  md-src="/static/images/icon-eye-alt.svg"
                  class="icon-download"
                />
                <span>Máscara</span>
              </button>

              <ButtonDropdown
                v-else-if="!toggle.rollbacklaudasa && dropdownOptions.length"
                selected-option="Máscara"
                width="160px"
                icon="icon-eye-alt"
                :it-may-change-selected-option="false"
                :initial-options="dropdownOptions"
                @option-selected="openExamMaskModal"
              />

              <button
                v-else-if="toggle.rollbacklaudasa"
                class="btn-primary btn-icon btn-mask"
                @click="openExamMaskModal(null)"
              >
                <md-icon
                  md-src="/static/images/icon-eye-alt.svg"
                  class="icon-download"
                />
                <span>Máscara</span>
              </button>
            </template>
          </div>
        </div>
      </div>
      <div class="exam-detail__wrapper">
        <div class="exam-detail__spacer" />
        <div class="exam-detail__content">
          <!-- production area -->
          <div class="exam-detail__production exam-detail__section">
            <div
              id="producao"
              class="exam-detail__anchor"
            />
            <div
              class="exam-detail__section-title"
              style="margin-top: 25px"
            >
              <div class="exam-detail__title-icon">
                <img
                  src="/static/images/site/icon-producao.svg"
                  alt="icone"
                />
              </div>
              <h2>Produção do exame</h2>
            </div>
            <examMaterial
              :method="exam.examMethod"
              :materials="exam.materials"
            />

            <div
              ref="referenceValuesBlock"
              class="exam-detail__card-reference-values"
            >
              <div class="exam-detail__card-title">Valor de Referência</div>
              <template v-if="profile && finalReferenceValues">
                <div
                  v-if="
                    !toggle.rollbacklaudasa &&
                    finalReferenceValues.values &&
                    finalReferenceValues.values.length > 0
                  "
                  class="exam-detail__reference-format-header"
                >
                  <div class="exam-detail__subtitle">
                    Clique para visualizar o VR conforme NTO de Execução, metodologia e
                    data.
                  </div>
                  <button
                    v-if="shouldBeUsedNewLayout && originalReferenceValues"
                    class="exam-detail__format-toggle-btn"
                    @click="toggleFormatView"
                  >
                    <md-tooltip>
                      {{ showLegacyFormat ? 'Ver novo formato' : 'Ver formato anterior' }}
                    </md-tooltip>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="1 4 1 10 7 10"></polyline>
                      <polyline points="23 20 23 14 17 14"></polyline>
                      <path
                        d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
                      ></path>
                    </svg>
                  </button>
                </div>
                <template
                  v-if="
                    (!toggle.rollbacklaudasa &&
                      finalReferenceValues.values &&
                      finalReferenceValues.values.length > 0) ||
                    (toggle.rollbacklaudasa &&
                      ignoreRollbackLaudasaExams.includes(exam.code))
                  "
                >
                  <template
                    v-if="
                      shouldBeUsedNewLayout &&
                      !showLegacyFormat &&
                      !toggle.rollbacklaudasa
                    "
                  >
                    <ReferenceValueNtoToggle
                      v-for="group in referenceValueNtoGroups"
                      :key="group.key"
                      :name="group.name"
                    >
                      <ReferenceValueToggle
                        v-for="item in group.values"
                        :key="item.key"
                        :reference-values="item.value"
                        :rollback-laudasa="toggle.rollbacklaudasa"
                        :use-new-layout="shouldBeUsedNewLayout"
                        :force-legacy-format="showLegacyFormat"
                        :profile="!!profile"
                        @register-new-format-data="handleNewFormatData"
                        @open-version-mask="handleOpenVersionMask"
                      />
                    </ReferenceValueNtoToggle>
                  </template>
                  <template v-else>
                    <div
                      v-for="(value, index) in finalReferenceValues.values"
                      :key="`ref-value-toggle-main-${index}-${value.id || index}`"
                    >
                      <ReferenceValueToggle
                        :reference-values="value"
                        :rollback-laudasa="toggle.rollbacklaudasa"
                        :use-new-layout="shouldBeUsedNewLayout"
                        :force-legacy-format="showLegacyFormat"
                        :profile="!!profile"
                        @register-new-format-data="handleNewFormatData"
                        @open-version-mask="handleOpenVersionMask"
                      />
                    </div>
                  </template>
                </template>
                <template v-else-if="toggle.rollbacklaudasa">
                  <div
                    v-for="(value, index) in finalReferenceValues.valuesOld"
                    :key="`ref-value-toggle-old-${index}-${value.id || index}`"
                  >
                    <ReferenceValueToggle
                      :reference-values="value"
                      :rollback-laudasa="toggle.rollbacklaudasa"
                      :use-new-layout="shouldBeUsedNewLayout"
                      :force-legacy-format="showLegacyFormat"
                      :profile="!!profile"
                      @open-version-mask="handleOpenVersionMask"
                    />
                  </div>
                </template>
                <template v-else>
                  <div>
                    Entrar em contato com a Assessoria científica através do telefone
                    <a href="tel:+08006438100">0800 643 8100</a>
                    opção 1.
                  </div>
                </template>
              </template>
              <div v-else>
                <template v-if="profile">
                  <div>Sem informações de Valores de Referência.</div>
                </template>
                <template v-else>
                  <div>Faça login para ver as informações de Valores de Referência.</div>
                  <button
                    class="exam-detail__btn"
                    @click="openLoginModal"
                  >
                    Fazer Login
                  </button>
                </template>
              </div>
            </div>
          </div>
          <!-- end production area -->

          <!-- execution time -->
          <div class="exam-detail__execution-time exam-detail__section">
            <div
              id="executionTime"
              class="exam-detail__anchor"
            />
            <div class="exam-detail__section-title">
              <div class="exam-detail__title-icon">
                <img
                  src="/static/images/exam-time.svg"
                  alt="icone"
                />
              </div>
              <h2>Prazo de execução</h2>
            </div>

            <div class="exam-detail__card">
              <div class="exam-detail__card-title">Prazo para o resultado*</div>
              <div class="exam-material__info">
                <div
                  v-for="(item, index) in exam.ntos"
                  :key="`nto-item-${index}-${item.id || item.code || index}`"
                  class="exam-material__stability-item"
                >
                  <div class="exam-material__sample">
                    <div>
                      {{ item.name }}
                    </div>
                  </div>
                  <div class="exam-material__time">
                    {{ `${item.deadline} ${item.deadlineUnit}` }}
                  </div>
                </div>
              </div>
            </div>

            <p>
              *Para exames com prazo informado em dias, este será considerado em
              <b>dias úteis</b>
              . Considerar o prazo a partir do recebimento da amostra no Núcleo Técnico
              Operacional (NTO). Amostras recebidas após as 17 horas terão os prazos
              iniciados no dia útil posterior
            </p>
          </div>
          <!-- end execution time -->

          <!-- instructions area -->
          <div
            v-if="showInstructions"
            class="exam-detail__instructions exam-detail__section"
          >
            <div
              id="instrucoes"
              class="exam-detail__anchor"
            />
            <div class="exam-detail__section-title">
              <div class="exam-detail__title-icon">
                <svg-loader src="/static/images/site/icon-instructions.svg" />
              </div>
              <h2>Instruções</h2>
            </div>
            <div
              v-if="exam.requirementCollect"
              class="exam-detail__card"
            >
              <div class="exam-detail__card-title">Informações de preparo e coleta</div>
              <div class="exam-detail__card-content">
                <div v-html="formatText(exam.requirementCollect)" />
              </div>
            </div>

            <div
              v-if="exam.relatedDocuments && exam.relatedDocuments.length > 0"
              class="exam-detail__documents"
            >
              <div class="exam-detail__card-title">Documentos obrigatórios</div>
              <div
                v-for="(document, index) in exam.relatedDocuments"
                :key="`doc-${index}-${document.id || index}`"
                class="exam-detail__document"
                :class="{
                  'exam-detail__document--clickable': document.base64,
                }"
                @click="document.base64 ? downloadDoc(document) : null"
              >
                <svg-loader src="/static/images/site/icon-document.svg" />
                {{ document.name }}
              </div>
            </div>
          </div>
          <!-- end instructions area -->
          <!-- interpretation area -->
          <div
            v-if="validInterpretation"
            class="exam-detail__interpretation exam-detail__section"
          >
            <div
              id="interpretacao"
              class="exam-detail__anchor"
            />
            <div class="exam-detail__section-title">
              <div class="exam-detail__title-icon">
                <svg-loader src="/static/images/site/icon-interpretation.svg" />
              </div>
              <h2>Interpretação</h2>
            </div>
            <div
              v-if="exam.interpretation"
              class="exam-detail__card exam-detail__card-interpretation"
            >
              <div class="exam-detail__card-title">Interpretação do exame</div>
              <div
                v-if="!showMoreInterpretation"
                class="exam-detail__card-content"
              >
                <div v-html="handleInterpretation(exam.interpretation)" />
              </div>

              <div
                v-else
                class="exam-detail__card-content"
              >
                <div v-html="formatText(exam.interpretation)" />
              </div>
              <div
                class="exam-detail__toggle"
                @click="showMoreInterpretation = !showMoreInterpretation"
              >
                {{ showMoreInterpretation ? 'Mostrar menos' : 'Leia mais' }}
                <img
                  :class="{
                    'exam-detail__arrow-down': !showMoreInterpretation,
                    'exam-detail__arrow-up': showMoreInterpretation,
                  }"
                  src="/static/images/site/icon-drop-down.svg"
                  alt="seta"
                />
              </div>
            </div>
            <div
              v-if="exam.interferers"
              class="exam-detail__card exam-detail__card-interpretation"
            >
              <div class="exam-detail__card-title">Interferentes</div>
              <div class="exam-detail__card-content">
                {{ exam.interferers }}
              </div>
            </div>
          </div>
          <!-- end interpretation area -->
          <!-- integration Params area -->
          <div
            v-if="showIntegration"
            class="exam-detail__integration exam-detail__section"
          >
            <div
              id="integracao"
              class="exam-detail__anchor"
            />
            <div class="exam-detail__section-title">
              <div class="exam-detail__title-icon">
                <svg-loader src="/static/images/site/icon-integration.svg" />
              </div>
              <h2>Integração</h2>
            </div>
            <div class="exam-detail__card exam-detail__card-integration">
              <div class="exam-detail__card-title">
                <h4>Parâmetros de integração</h4>
                <button
                  class="btn btn-primary"
                  @click="openIntegrationModal"
                >
                  Ver parâmetros
                </button>
              </div>
            </div>
          </div>
          <!-- end integration Params area -->
          <!-- related area -->
          <div
            v-if="showRelated"
            class="exam-detail__related exam-detail__section"
          >
            <div
              id="relacionados"
              class="exam-detail__anchor"
            />
            <div class="exam-detail__section-title">
              <div class="exam-detail__title-icon">
                <svg-loader src="/static/images/site/icon-related-exames.svg" />
              </div>
              <h2>Exames Relacionados</h2>
            </div>
            <exam-search-result :items="related" />

            <div
              v-if="related.length > 2"
              class="exam-detail__toggle exam-detail__relative-top"
              @click="showMoreRelated = !showMoreRelated"
            >
              {{ showMoreRelated ? 'Mostrar menos' : 'Ver mais' }}
              <img
                :class="{
                  'exam-detail__arrow-down': !showMoreRelated,
                  'exam-detail__arrow-up': showMoreRelated,
                }"
                src="/static/images/site/icon-drop-down.svg"
                alt="seta"
              />
            </div>
          </div>
          <div class="footer_print">
            <p>
              Data da geração
              <span>{{ datePDF }}</span>
            </p>
            <p>
              As informações deste documento podem sofrer alterações a qualquer momento,
              sem aviso prévio. Alvaro Apoio
            </p>
          </div>
          <!-- end related area -->
          <div class="exam-detail__footer-listener" />
        </div>
        <div
          v-if="toggle.examGuidePrice"
          class="exam-detail__actions"
        >
          <div
            ref="priceCard"
            class="exam-detail__price"
          >
            <div
              class="exam-detail__price-title"
              :class="{
                'exam-detail__price-title--small': profile && price !== 0,
              }"
            >
              Preço:
              <p
                v-if="profile && price && price !== 0"
                class="exam-detail__price-value"
              >
                R$ {{ price }}
              </p>
            </div>
            <div
              v-if="!profile"
              class="exam-detail__price-info"
            >
              <div class="exam-detail__price-img">
                <img
                  src="/static/images/site/icon-info.svg"
                  alt="info"
                />
              </div>
              <div class="exam-detail__price-text">
                Faça login para ver o preço deste exame e mais informações.
              </div>
              <button
                class="exam-detail__btn"
                @click="openLoginModal"
              >
                Fazer Login
              </button>
            </div>
            <div
              v-else-if="profile && price === 0"
              class="exam-detail__price-info"
            >
              <div class="exam-detail__price-img">
                <img
                  src="/static/images/site/icon-info.svg"
                  alt="info"
                />
              </div>
              <div class="exam-detail__price-text">
                O preço deste exame encontra-se indisponível no momento. Solicite-o ao seu
                <b>executivo de vendas</b>
                , ou peça um orçamento abaixo.
              </div>
            </div>
            <a
              v-if="profile"
              class="exam-detail__btn"
              href="https://alvaroapoio.com.br/orcamento"
            >
              <svg-loader src="/static/images/site/icon-instructions.svg" />
              Solicitar orçamento
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!loading"
      v-observe-visibility="reachedBottom"
      class="exam-detail__bottom-helper"
    />
    <LoginModal ref="loginModal" />
    <IntegrationModalParams
      ref="integrationModal"
      :new-format-reference-values="newFormatReferenceValues"
    />
    <ExamMask
      v-if="examMaskModal"
      :exam="exam"
      :rollback-laudasa="toggle.rollbacklaudasa"
      :reference-values="referenceValuesObject"
      :is-ignored-by-exam="ignoreRollbackLaudasaExams.includes(exam.code)"
      :selected-nto="selectedNto"
      :use-new-layout="shouldBeUsedNewLayout"
      :version-criticisms="examMaskVersionCriticisms"
      :version-methodology="examMaskVersionMethodology"
      @close="closeExamMaskModal"
    />
    <ExamMaskInfoModal
      v-if="examMaskInfoModal"
      @close="examMaskInfoModal = false"
      @confirm="scrollToReferenceValues"
    />
  </div>
</template>
<script>
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'
import ButtonDropdown from '@/components/common/buttonComponent/ButtonDropdown.vue'
import BreadCrumbs from './components/BreadCrumbs.vue'
import ExamSearch from './components/ExamSearch.vue'
import ExamMaterial from './components/ExamMaterial.vue'
import Spinner from '../common/Spinner.vue'
import ExamSearchResult from './components/ExamList.vue'
import LoginModal from './components/LoginModal.vue'
import IntegrationModalParams from './components/IntegrationModalParams.vue'
import ExamMask from './components/ExamMask.vue'
import ExamMaskInfoModal from './components/ExamMaskInfoModal.vue'
import ReferenceValueToggle from './components/ReferenceValueToggle.vue'
import ReferenceValueNtoToggle from './components/ReferenceValueNtoToggle.vue'

import notify from '@/api/notification'
import examGuideService from '@/api/examGuide'
import { justDownloadBase64File } from '@/utils/convertBase64ToFile'
import { formatPrice } from '@/utils/formatPrice'

import { mapGetters } from 'vuex'

export default {
  name: 'ExamDetail',
  components: {
    ButtonCopy,
    ButtonDropdown,
    BreadCrumbs,
    ExamSearch,
    ExamMaterial,
    Spinner,
    ExamSearchResult,
    LoginModal,
    IntegrationModalParams,
    ExamMask,
    ExamMaskInfoModal,
    ReferenceValueToggle,
    ReferenceValueNtoToggle,
  },
  data: () => ({
    loading: false,
    showMoreInterpretation: false,
    showMoreSynonym: false,
    showMoreRelated: false,
    showMoreReference: false,
    runNotificationPDF: false,
    exam: {},
    examMaskModal: false,
    examMaskInfoModal: false,
    examMaskVersionCriticisms: null,
    examMaskVersionMethodology: null,
    selectedNto: null,
    ignoreRollbackLaudasaExams: ['HEDTA'],
    apiReferenceValues: null,
    shouldBeUsedNewLayout: false,
    showLegacyFormat: false,
    originalReferenceValues: null,
    newFormatReferenceValues: [],
    axiosInterceptor: null,
  }),
  computed: {
    ...mapGetters(['profile', 'toggle']),
    price() {
      if (!isNaN(this.exam.nationalPrice)) {
        if (this.exam.nationalPrice === null) {
          return 0
        }
        return formatPrice(this.exam.nationalPrice)
      }
    },
    datePDF: () => {
      const today = new Date()
      // Date
      const dd = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
      const mm =
        today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1
      const year = today.getFullYear()
      // Hour
      const hour = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
      const minutes =
        today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
      const dateFormated = `${dd}/${mm}/${year} - ${hour}:${minutes}`
      return dateFormated
    },
    showInstructions() {
      return (
        (this.exam.relatedDocuments && this.exam.relatedDocuments.length > 0) ||
        this.exam.requirementCollect
      )
    },
    validInterpretation() {
      return this.exam.interpretation || this.interferers
    },
    showIntegration() {
      return true
    },
    related() {
      let related
      if (this.exam && this.exam.codeRelatedExams) {
        related = this.exam.codeRelatedExams
        if (related.length >= 3 && !this.showMoreRelated) {
          return related.slice(0, 3)
        }
      }
      return related
    },
    showRelated() {
      if (this.exam.codeRelatedExams && this.exam.codeRelatedExams.length > 0) {
        return true
      }
      return false
    },
    sections() {
      return document.getElementsByClassName('exam-detail__section')
    },
    anchors() {
      if (this.$refs.anchorsList) {
        return this.$refs.anchorsList.getElementsByTagName('div')
      }
      return []
    },
    dropdownOptions() {
      const finalValues = this.finalReferenceValues
      if (finalValues && finalValues.values && finalValues.values.length) {
        const firstValue = finalValues.values[0]
        if (firstValue.executationNto) {
          return finalValues.values
            .filter(value => value.executationNto && value.executationNto.length > 0)
            .flatMap(value => value.executationNto.map(nto => nto.name))
        }

        const ntos = finalValues.values
          .map(ntoList => ntoList.executionNto)
          .flatMap(ntoString => (ntoString ? ntoString.split('/') : []))
        return ntos
      }

      return []
    },
    referenceValuesObject() {
      const finalValues = this.finalReferenceValues
      return finalValues ? finalValues : false
    },
    referenceValueNtoGroups() {
      const finalValues = this.finalReferenceValues
      const values = finalValues && finalValues.values ? finalValues.values : []
      const groups = []
      const groupsByKey = {}

      const addToGroup = (key, name, value, valueIndex) => {
        if (!groupsByKey[key]) {
          groupsByKey[key] = {
            key,
            name,
            values: [],
          }
          groups.push(groupsByKey[key])
        }

        this.buildReferenceValueCards(value, valueIndex).forEach(card => {
          groupsByKey[key].values.push(card)
        })
      }

      values.forEach((value, valueIndex) => {
        const ntos = value.executationNto
        if (!Array.isArray(ntos) || ntos.length === 0) {
          addToGroup('without-nto', 'NTO não informado', value, valueIndex)
          return
        }

        const key = ntos
          .map(nto => nto.id || nto.executationCode || nto.name || '')
          .join('|')
        const name = ntos.map(nto => nto.name || 'NTO não informado').join('/')
        addToGroup(key, name, value, valueIndex)
      })

      groups.forEach(group => {
        group.values = this.filterUniqueReferenceValueCardsByDate(group.values).slice(
          0,
          5
        )
      })

      return groups
    },
    finalReferenceValues() {
      const shouldUseAPI =
        !this.toggle.rollbacklaudasa ||
        (this.toggle.rollbacklaudasa &&
          this.ignoreRollbackLaudasaExams.includes(this.exam.code))

      if (this.showLegacyFormat && this.originalReferenceValues) {
        return this.originalReferenceValues
      }

      if (shouldUseAPI && this.apiReferenceValues) {
        return this.apiReferenceValues
      }

      return this.exam.referenceValues && this.exam.referenceValues.length > 0
        ? this.exam.referenceValues[0]
        : null
    },
  },
  watch: {
    $route(to, from) {
      const lastMnemonic = to.query.mnemonic
      const mnemonic = from.query.mnemonic
      if (mnemonic && lastMnemonic && mnemonic !== lastMnemonic) {
        this.loadExam(lastMnemonic)
      }
    },
  },
  async mounted() {
    try {
      await this.$recaptchaLoaded()
      this.setupRecaptchaInterceptor()
    } catch (error) {
      console.error('Erro ao carregar reCAPTCHA:', error)
    }

    window.addEventListener('scroll', this.getScrollAndSetPosition)
    if (this.$route.query.mnemonic) {
      this.loadExam(this.$route.query.mnemonic)
    }
  },
  beforeDestroy() {
    if (this.axiosInterceptor !== null) {
      examGuideService.axios().interceptors.request.eject(this.axiosInterceptor)
    }

    if (this.$recaptchaInstance) {
      this.$recaptchaInstance.hideBadge()
    }

    window.removeEventListener('scroll', this.getScrollAndSetPosition)
  },
  methods: {
    setupRecaptchaInterceptor() {
      this.axiosInterceptor = examGuideService.axios().interceptors.request.use(
        async config => {
          if (config.baseURL === process.env.EXAM_GUIDE_URL) {
            try {
              const token = await this.$recaptcha('exam_guide_request')
              config.headers['X-Recaptcha-Token'] = token
            } catch (error) {
              console.error('Erro ao obter token reCAPTCHA:', error)
            }
          }
          return config
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    scrollSmoothTo(elementId) {
      const element = document.getElementById(elementId)
      element.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      })
    },
    reachedBottom(isVisible) {
      let card = this.$refs.priceCard
      if (isVisible) {
        card.classList.toggle('exam-detail__price--absolute')
      } else {
        card.classList.remove('exam-detail__price--absolute')
      }
    },
    handleBackButton() {
      this.$router.push('/exames')
    },
    handleNewFormatData(data) {
      if (data.isNewApiFormat) {
        this.newFormatReferenceValues.push(data)
      }
    },
    formatText(str) {
      if (str) {
        return str.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }
      return ''
    },
    buildReferenceValueCards(value, valueIndex) {
      const currentDate = new Date(value.dateUpdated).getTime()
      const cards = [
        {
          key: `ref-value-${valueIndex}-current`,
          value: { ...value, versions: [] },
          date: currentDate,
        },
      ]

      const groups = this.groupReferenceVersions(value.versions || [])
      groups.forEach((versionGroup, groupIndex) => {
        const date = this.getReferenceVersionDate(versionGroup)
        if (Number.isFinite(currentDate) && date >= currentDate) return

        const criticisms = this.mergeReferenceVersionCriticisms(
          value.criticism || [],
          versionGroup
        )
        const methodologies = [
          ...new Set(criticisms.map(criticism => criticism.methodology).filter(Boolean)),
        ].sort((a, b) => b.length - a.length)

        cards.push({
          key: `ref-value-${valueIndex}-history-${groupIndex}`,
          value: {
            ...value,
            criticism: criticisms,
            dateUpdated: this.getReferenceVersionUpdatedDate(versionGroup),
            methodology: methodologies.join(' | ') || value.methodology || '',
            versions: [],
          },
          date,
        })
      })

      const uniqueCardsByDisplayedDate = []
      const displayedDates = new Set()

      cards
        .sort((a, b) => b.date - a.date)
        .forEach(card => {
          const displayedDate = this.getReferenceVersionDisplayDate(
            card.value.dateUpdated
          )
          if (!displayedDate || displayedDates.has(displayedDate)) return

          displayedDates.add(displayedDate)
          uniqueCardsByDisplayedDate.push(card)
        })

      return uniqueCardsByDisplayedDate.slice(0, 5)
    },
    filterUniqueReferenceValueCardsByDate(cards) {
      const displayedDates = new Set()

      return cards
        .sort((a, b) => b.date - a.date)
        .filter(card => {
          const displayedDate = this.getReferenceVersionDisplayDate(
            card.value.dateUpdated
          )
          if (!displayedDate || displayedDates.has(displayedDate)) return false

          displayedDates.add(displayedDate)
          return true
        })
    },
    groupReferenceVersions(versions) {
      const groups = []
      let currentGroup = []
      let baseTime = null

      versions.forEach(version => {
        const versionTime = new Date(version.dtCreated).getTime()
        if (!Number.isFinite(versionTime)) return

        if (baseTime === null) {
          baseTime = versionTime
          currentGroup.push(version)
          return
        }

        const diffMinutes = Math.abs(versionTime - baseTime) / (1000 * 60)
        if (diffMinutes <= 2) {
          currentGroup.push(version)
          return
        }

        groups.push(currentGroup)
        currentGroup = [version]
        baseTime = versionTime
      })

      if (currentGroup.length > 0) groups.push(currentGroup)
      return groups
    },
    getReferenceVersionDate(versionGroup) {
      return Math.max(
        ...versionGroup.map(version => new Date(version.dtUpdated).getTime())
      )
    },
    getReferenceVersionUpdatedDate(versionGroup) {
      return versionGroup
        .slice()
        .sort(
          (a, b) => new Date(b.dtUpdated).getTime() - new Date(a.dtUpdated).getTime()
        )[0].dtUpdated
    },
    getReferenceVersionDisplayDate(date) {
      const dateTime = new Date(date)
      if (!Number.isFinite(dateTime.getTime())) return ''

      const pad = value => String(value).padStart(2, '0')
      const day = pad(dateTime.getUTCDate())
      const month = pad(dateTime.getUTCMonth() + 1)
      const year = dateTime.getUTCFullYear()
      const hour = pad(dateTime.getUTCHours())
      const minutes = pad(dateTime.getUTCMinutes())
      const seconds = pad(dateTime.getUTCSeconds())

      return `${day}/${month}/${year} às ${hour}:${minutes}:${seconds}`
    },
    mergeReferenceVersionCriticisms(criticisms, versionGroup) {
      const merged = JSON.parse(JSON.stringify(criticisms))
      const byId = {}
      const byName = {}
      const add = (map, key, value) => {
        if (key == null) return
        if (!map[key]) map[key] = []
        map[key].push(value)
      }

      versionGroup.forEach(version => {
        const entries = version.criticism || [version]
        entries.forEach(entry => {
          const value = { ...entry, dtCreated: version.dtCreated }
          add(byId, entry.id, value)
          add(byName, entry.name, value)
        })
      })

      const mostRecent = map => {
        Object.keys(map).forEach(key => {
          map[key] = map[key].sort(
            (a, b) => new Date(b.dtCreated).getTime() - new Date(a.dtCreated).getTime()
          )[0]
        })
      }
      mostRecent(byId)
      mostRecent(byName)

      return merged.map(criticism => {
        const versionData = byId[criticism.id] || byName[criticism.name]
        return versionData
          ? { ...criticism, ...versionData, id: criticism.id, isModified: true }
          : criticism
      })
    },
    visibilityChanged(isVisible) {
      if (!isVisible) {
        let header = document.querySelector('.exam-detail__fixed')
        if (header) {
          header.classList.add('exam-detail__fixed--active')
        }
      } else {
        let header = document.querySelector('.exam-detail__fixed--active')
        if (header) {
          header.classList.remove('exam-detail__fixed--active')
        }
      }
    },
    handleNavActive(event, link) {
      let item = event
      if (item.target) {
        item = event.target
      }
      let current = document.querySelector('.exam-detail__nav-link--active')
      current.classList.remove('exam-detail__nav-link--active')
      item.classList.add('exam-detail__nav-link--active')
      this.scrollSmoothTo(link)
    },
    loadExam(mnemonic) {
      let searchText = mnemonic
      searchText = searchText.replace(/ /g, '%20')
      this.loading = true
      this.showMoreInterpretation = false
      this.showMoreSynonym = false
      this.showMoreRelated = false
      this.apiReferenceValues = null
      this.newFormatReferenceValues = []

      if (this.profile) {
        examGuideService
          .getRestrictedExamDetailsByMnemonic(searchText)
          .then(response => {
            this.exam = response.data
            this.loadReferenceValuesIfNeeded()
          })
          .catch(err => {
            notify({
              title: 'AVISO:',
              message: err.response?.data?.message || 'Erro ao carregar o exame',
            })
            this.loading = false
            this.$router.push('/exames')
          })
      } else {
        examGuideService
          .getExamDetailsByMnemonic(searchText)
          .then(response => {
            this.exam = response.data
            this.loading = false
            window.scrollTo(0, 0)
          })
          .catch(err => {
            notify({
              title: 'AVISO:',
              message: err.response?.data?.message || 'Erro ao carregar o exame',
            })
            this.loading = false
            this.$router.push('/exames')
          })
      }
    },
    loadReferenceValuesIfNeeded() {
      const shouldLoadFromAPI =
        !this.toggle.rollbacklaudasa ||
        (this.toggle.rollbacklaudasa &&
          this.ignoreRollbackLaudasaExams.includes(this.exam.code))

      if (shouldLoadFromAPI && this.exam.code) {
        if (this.exam.referenceValues && this.exam.referenceValues.length > 0) {
          this.originalReferenceValues = JSON.parse(
            JSON.stringify(this.exam.referenceValues[0])
          )
        }

        examGuideService
          .getExamReferenceValues(this.exam.code)
          .then(response => {
            this.apiReferenceValues = this.processApiReferenceValues(response.data)
            this.loading = false
            window.scrollTo(0, 0)
            this.shouldBeUsedNewLayout = true
          })
          .catch(err => {
            console.error('Erro ao carregar valores de referência:', err)
            this.apiReferenceValues = null
            this.loading = false
            window.scrollTo(0, 0)
            this.shouldBeUsedNewLayout = false
          })
      } else {
        this.shouldBeUsedNewLayout = false
        this.loading = false
        window.scrollTo(0, 0)
      }
    },
    processApiReferenceValues(apiData) {
      if (Array.isArray(apiData)) {
        return {
          values: apiData,
          valuesOld: apiData,
        }
      } else if (apiData && apiData.values) {
        return apiData
      } else if (apiData) {
        return {
          values: [apiData],
          valuesOld: [apiData],
        }
      } else {
        return {
          values: [],
          valuesOld: [],
        }
      }
    },
    handleSynomym(text) {
      if (text) {
        for (let i = 250; i >= 0; i--) {
          if (text.charAt(i) === ' ') {
            let str = text.slice(0, i) + '...'
            str = this.formatText(str)
            return str
          }
        }
      }
    },
    handleInterpretation(text) {
      if (text) {
        for (let i = 620; i >= 0; i--) {
          if (text.charAt(i) === ' ') {
            let str = text.slice(0, i) + '...'
            str = this.formatText(str)
            return str
          }
        }
      }
    },
    activeItemOnMenu(list, element) {
      list.forEach(el => {
        el.classList.remove('exam-detail__nav-link--active')
      })
      element.classList.add('exam-detail__nav-link--active')
    },
    getScrollAndSetPosition() {
      setTimeout(() => {
        const scroll = window.pageYOffset
        const endPage =
          document.documentElement.scrollHeight - document.documentElement.clientHeight
        let currentElement = this.anchors[0]

        if (scroll >= endPage) {
          currentElement = this.anchors[this.anchors.length - 1]
        } else {
          this.sections.forEach((section, index) => {
            let sectionTop = section.offsetTop
            if (scroll > sectionTop - 250) {
              currentElement = this.anchors[index]
            }
          })
        }

        currentElement && this.activeItemOnMenu(this.anchors, currentElement)
      }, 100)
    },
    openIntegrationModal() {
      this.$refs.integrationModal.openIntegrationModal()
    },
    openLoginModal() {
      this.$refs.loginModal.openLoginModal()
    },
    downloadDoc(doc) {
      const fileName = doc.name
      const fileExtension = fileName.split('.')[1]
      const contentType = 'application/' + fileExtension

      justDownloadBase64File(contentType, doc.base64, fileName)
    },
    downloadPDF() {
      this.showMoreInterpretation = true
      this.showMoreSynonym = true
      this.showMoreRelated = true
      this.showMoreReference = true
      window.scrollTo(0, 0)
      setTimeout(() => {
        print()
      }, 1000)
    },
    isIE() {
      let ua = navigator.userAgent
      let isIEBrowser = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1

      return isIEBrowser
    },
    copyToClipboard(text) {
      const cb = navigator.clipboard

      if (cb) {
        cb.writeText(text)
      } else {
        window.clipboardData.setData('Text', text)
      }
    },
    formatResponseText(text) {
      return text.replace(/\n/g, '<span class="space"></span>')
    },
    closeExamMaskModal() {
      this.examMaskModal = false
      this.selectedNto = null
      this.examMaskVersionCriticisms = null
      this.examMaskVersionMethodology = null
    },
    openExamMaskModal(selected) {
      this.selectedNto = selected
      this.examMaskVersionCriticisms = null
      this.examMaskVersionMethodology = null
      this.examMaskModal = true
    },
    openExamMaskInfoModal() {
      this.examMaskInfoModal = true
    },
    scrollToReferenceValues() {
      this.examMaskInfoModal = false
      this.$nextTick(() => {
        const el = this.$refs.referenceValuesBlock
        if (el) {
          const offset = 320
          const y = el.getBoundingClientRect().top + window.scrollY - offset
          window.scrollTo({ top: y, behavior: 'smooth' })
        }
      })
    },
    handleOpenVersionMask({ criticisms, methodology }) {
      this.examMaskVersionCriticisms = criticisms
      this.examMaskVersionMethodology = methodology
      this.selectedNto = null
      this.examMaskModal = true
    },
    toggleFormatView() {
      this.showLegacyFormat = !this.showLegacyFormat
    },
  },
}
</script>

<style lang="scss">
.exam-detail {
  background-image: url('/static/images/site/bg-bottom-detail.png');
  background-color: #f7f7f7;
  background-position: 100% 100%;
  background-size: 500px;
  background-repeat: no-repeat;
  padding-bottom: 50px;

  &__fixed {
    background-image: url('/static/images/site/bg-detail1.svg');
    background-color: #f7f7f7;
    background-position: 0 -85px;
    background-repeat: no-repeat;
  }

  h4 {
    color: #303030;
    letter-spacing: 0;
    font-size: 14px;
    font-weight: 600;
  }

  &__bottom-helper {
    position: relative;
    top: 170px;
  }
  &__documents {
    background-color: #fff;
    border-left: 4px solid #ef9a4b;
    border-radius: 5px;
    padding: 12px 16px 12px 12px;
    margin-top: 10px;

    .md-icon {
      width: 20px;
      min-width: 20px;
      margin: 0;
      margin-right: 10px;
    }
  }
  &__document {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
    color: #303030;
    margin: 5px 0;

    svg {
      margin-right: 8px;
    }

    &--clickable {
      cursor: pointer;
      transition: color 0.2s ease;

      &:hover {
        color: #7f1a54;
        text-decoration: underline;
      }
    }
  }
  &__footer-listener {
    position: absolute;
    bottom: 0;
  }
  &__fixed {
    &--active {
      position: fixed;
      width: 100%;
      top: 0;
      background-color: #f7f7f7;
      z-index: 108;

      .exam-detail__synonyms,
      .exam-detail__title-tags {
        display: none;
      }

      & + div {
        padding-top: 170px;
      }
    }
  }
  &__synonyms {
    &-text {
      text-transform: uppercase;
    }
  }
  &__title {
    padding-top: 50px;
    h1 {
      font-weight: 600;
      font-size: 26px;
      color: #7f1a54;
      letter-spacing: 0;
    }
  }
  &__alert {
    margin-top: 10px;
    font-size: 12px;
    color: #e2245a;
    font-style: italic;
    font-weight: normal;
    display: flex;
    align-items: center;

    img {
      margin-right: 3px;
    }
  }
  &__wrapper {
    display: flex;
  }
  &__spacer {
    width: 10%;
  }
  &__content {
    width: 63%;
  }
  &__actions {
    width: 27%;
    padding-left: 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__btn_export_pdf {
      font-family: 'Exo 2', sans-serif;
      margin-top: 38px;
      background: none;
      color: #7a7a7a;
      text-transform: uppercase;
      .icon_exportPDF {
        margin-right: 10px;
      }
      &:hover {
        color: #7f1a54;
        svg path:nth-child(1) {
          fill: #7f1a54;
        }
      }
    }
  }
  &__mask-btn-wrapper {
    position: relative;
    display: inline-flex;
  }
  &__price-title {
    color: #818181;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;

    &--small {
      font-size: 14px;
      font-weight: 500;
    }
  }
  &__price-value {
    font-size: 24px;
    color: #7f1a54;
    font-weight: 700;
  }
  &__price-info {
    display: flex;
    flex-wrap: wrap;
  }
  &__price-img {
    margin-right: 10px;
    display: flex;
    justify-content: center;
  }
  &__price-text {
    width: calc(100% - 28px);
    font-size: 13.33px;
    line-height: 16px;
    color: #818181;
  }
  &__price {
    background-color: #fff;
    border-radius: 4px;
    padding: 15px;
    border-left: 4px solid #7f1a54;
    position: fixed;
    bottom: 20px;
    margin-right: 80px;
    z-index: 2;
    flex-grow: 1;

    &--absolute {
      position: absolute;
      bottom: -165px;
    }
  }
  &__production {
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 18px;
      color: rgba(74, 74, 74, 1);
      letter-spacing: 0;
      margin: 0;
    }
    .exam-detail__title-icon {
      background-color: #7f1a54;
    }
  }
  &__execution-time {
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      color: #7a7a7a;
      letter-spacing: 0;
      margin: 10px 0;
    }
    .exam-detail__title-icon {
      background-color: #b0234b;
    }
  }
  &__instructions {
    .exam-detail__title-icon {
      background-color: #b0234b;
    }
  }
  &__interpretation {
    .exam-detail__title-icon {
      background-color: #e2245a;
    }
  }
  &__reference-values,
  &__reference-name {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    &-content {
      width: calc(100% - 32px);
    }

    &:hover {
      background-color: rgba(127, 26, 84, 0.08);

      .btn-copy {
        opacity: 1;
      }
    }
  }
  &__integration {
    h4 {
      color: #303030;
      font-size: 16px;
      font-weight: 700;
    }

    .exam-detail__card-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .exam-detail__title-icon {
      background-color: #e2245a;
    }

    .btn {
      width: 162px;
      font-weight: 500;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
    }
  }
  &__related {
    .exam-detail__title-icon {
      background-color: #ee5c53;
    }
  }
  &__top {
    display: flex;
    justify-content: space-between;

    .exam-search__select {
      position: relative;
      top: 20px;
      min-width: 400px;
      left: -75px;
      z-index: 1;
    }
  }
  &__title-tags {
    display: flex;
    margin-top: 20px;
  }
  &__tag-wrapper {
    margin-bottom: 20px;
    margin-right: 30px;
  }
  &__tag {
    background-color: #bbbbbb;
    color: #fff;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 1px;
    text-align: center;
    padding: 3px 16px;
    border-radius: 5px;
    margin-top: 5px;
  }
  &__nav {
    margin-top: 25px;
    display: flex;
    border-bottom: 1px solid #d6d6d6;
  }
  &__nav-link {
    padding: 8px 20px;
    font-size: 14px;
    color: #7a7a7a !important;
    cursor: pointer;
    text-decoration: none !important;

    &--active {
      font-weight: 600;
      color: #7f1a54 !important;
      border-bottom: 2px solid #7f1a54;
    }
  }

  &__return {
    position: absolute;
    left: -35px;
    top: 2px;
    cursor: pointer;
  }
  &__main-title {
    position: relative;
    display: flex;
    flex-direction: column;
  }
  &__section-title {
    display: flex;
    align-items: center;
    margin: 40px 0 25px;

    h2 {
      font-weight: 500;
      font-size: 18px;
      color: #303030;
    }
  }
  &__title-icon {
    width: 32px;
    height: 32px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
  }
  &__loading {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__toggle {
    font-size: 13px;
    line-height: 26px;
    text-align: center;
    text-decoration-line: underline;
    color: #7f1a54;
    pad: 5px 0 10px;
    cursor: pointer;

    img {
      margin-left: 3px;
      position: relative;
      top: -2px;
    }
  }
  &__relative-top {
    position: relative;
    top: -15px;
  }
  &__card {
    background-color: #fff;
    border-left: 4px solid #b0234b;
    padding: 12px 16px 12px 12px;
    border-radius: 5px;
    font-weight: normal;
    font-size: 16px;
    color: #303030;
    margin-bottom: 8px;

    &-title {
      color: #7a7a7a;
      font-size: 14px;
      margin-bottom: 3px;
    }
  }
  &__reference-values-title {
    display: flex;
    justify-content: space-between;
  }
  &__mini-title {
    width: calc(50% - 4px);
    font-size: 12px;
    color: #7f1a54;
    padding: 8px 3px;
  }

  &__subtitle {
    font-size: 12px;
    color: #303030;
  }
  &__reference-format-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;

    .exam-detail__mini-title {
      width: auto;
      flex: 1;
    }
  }
  &__format-toggle-btn {
    background-color: #fff;
    border: 2px solid #7f1a54;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    min-width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;

    svg {
      color: #7f1a54;
      transition: transform 0.3s ease;
    }

    &:hover {
      background-color: #7f1a54;
      transform: scale(1.05);

      svg {
        color: #fff;
      }
    }

    &:active {
      transform: scale(0.95);
    }
  }
  &__reference-row {
    display: flex;
    margin-bottom: 8px;
    background-color: #fff;
    justify-content: space-between;

    & > div {
      width: calc(50% - 4px);
      border-radius: 3px;
      background-color: #f5f5f5;
      padding: 12px 8px;

      .btn-copy {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        opacity: 0;
        transition: opacity ease 0.4s;
      }
    }
  }

  &__card-reference-values {
    background-color: #fff;
    padding: 12px;
    border-left: 4px solid #7f1a55;
    border-radius: 4px;
    margin-top: 8px;

    .exam-detail__mini-title {
      padding-bottom: 0;
    }
  }

  &__reference-name {
    font-size: 16px;
    color: #303030;
    font-weight: bold;
  }
  &__reference-value {
    color: #7a7a7a;
    font-size: 13px;
    margin-bottom: 8px;

    &:last-of-type {
      margin-bottom: 0;
    }

    .space {
      display: block;
      padding: 4px 0;
    }
  }
  &__card-interpretation,
  &__card-integration {
    border-color: #e2245a;
  }
  &__arrow-up {
    transform: rotate(180deg);
    top: 2px !important;
  }

  &__btn {
    background-color: transparent;
    border: 2px solid #7f1a54;
    color: #7f1a54 !important;
    text-transform: uppercase;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 100%;
    margin-top: 15px;
    font-family: 'Exo 2', sans-serif !important;
    padding: 0 0.6em;
    font-weight: 600;
    transition: all ease-in-out 0.4s;

    .md-icon {
      width: 20px;
      min-width: 20px;
      margin: 0;
      margin-right: 4px;
    }

    svg path {
      fill: #7f1a54;
    }

    &:hover {
      color: #fff !important;
      background-color: #7f1a54;
      text-decoration: none !important;

      svg path {
        fill: #fff;
      }
    }
  }

  .btn-mask {
    width: 160px;
    font-weight: 500;
    text-transform: uppercase;
    font-family: 'Exo 2', sans-serif !important;
    padding: 10px 15px;
    cursor: pointer;
    color: #fff;

    span {
      font-weight: 600;
    }

    &.btn-icon {
      display: flex;
      justify-content: center;
      align-items: center;

      .md-icon {
        width: 18px;
        min-width: 18px;
        margin: 0;
        margin-right: 8px;
      }
    }
  }
}

#instrucoes,
#interpretacao,
#integracao,
#relacionados,
#producao,
#executionTime {
  position: relative;
  top: -320px;
}
.exam-detail__fixed--active + .exam-detail__wrapper #instrucoes,
.exam-detail__fixed--active + .exam-detail__wrapper #interpretacao,
.exam-detail__fixed--active + .exam-detail__wrapper #integracao,
.exam-detail__fixed--active + .exam-detail__wrapper #relacionados,
.exam-detail__fixed--active + .exam-detail__wrapper #producao,
.exam-detail__fixed--active + .exam-detail__wrapper #executionTime {
  top: -180px;
}
.site-header__logo_pdf {
  display: none;
}
.footer_print {
  display: none;
}

@media print {
  .exam-detail {
    background: none;
  }
  .exam-detail__return {
    display: none;
  }
  .grecaptcha-badge {
    display: none !important;
  }
  .site-header__logo_pdf {
    display: block;
    margin-bottom: 60px;
  }
  .exam-material__info {
    line-height: 1.6;
    word-wrap: break-word;
    width: 700px !important;
  }
  .exam-detail__main-title {
    h1 {
      word-wrap: break-word;
      width: 90%;
      line-height: 1.6;
      color: #000 !important;
    }
  }
  .exam-detail__tag {
    background: none;
    color: #303030;
    text-align: start;
    padding: 0;
  }
  .site-header {
    display: none;
  }
  .btn {
    display: none;
  }
  .site-header-bar {
    display: none;
  }
  .exam-detail__top {
    display: none;
  }
  .site-header-bar-mobile {
    display: none;
  }
  .site-header-mobile {
    display: none;
  }
  .exam-material__title {
    background: white !important;
    border: 1px solid #000000;
    border-radius: 3px;
    color: black !important;
    display: flex;
  }
  .exam-detail__content {
    width: 75%;
  }
  .exam-material__btn {
    display: none;
  }
  .exam-detail__card {
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;
  }
  .exam-detail__toggle {
    display: none;
  }
  .exam-detail__nav {
    display: none;
  }
  .footer_print {
    margin-top: 10px;
    display: flex !important;
    justify-content: center !important;
    flex-direction: column !important;
    align-items: center !important;
    p {
      text-align: center;
    }
  }
  body {
    background-color: #bbbbbb;
  }
  .exam-detail__integration {
    display: none;
  }
  .exam-material__full {
    background: white;
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;
  }
  .exam-detail__actions {
    display: none;
  }
  .exam-detail__related {
    display: none;
  }
  .exam-detail__card-interpretation {
    background: white;
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;
  }
  .exam-detail__card-reference-values {
    background: white;
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;
  }
  .exam-material__title-dinamic {
    font-size: 15px;
    margin-left: 5px;
  }
  .exam-detail__mini-title {
    color: black;
  }
  .exam-detail__title-icon {
    display: none;
  }
  .footer-cta {
    display: none;
  }
  .main-footer-container {
    display: none;
  }
  .exam-material__half {
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;
  }
  .exam-detail__card-title {
    color: #000000;
  }
  .exam-detail__documents {
    color: #000000 !important;
    border: 1px solid #000 !important;
    border-left: 4px solid #000 !important;

    .exam-detail__document {
      flex-direction: inherit;
      background: none;
      color: #000000 !important;
      margin-top: 0;
      padding: 0;
      word-wrap: break-word;
      width: 98%;
      svg path {
        fill: #000;
      }
    }
    button {
      display: none !important;
    }
  }
  .rc-anchor-content {
    display: none;
  }
  .exam-detail__wrapper {
    background: white;
  }
  .exam-detail__document {
    flex-direction: inherit;
    background: none;
    color: #000000 !important;
    margin-top: 0;
    padding: 0;
    word-wrap: break-word;
    width: 98%;
    svg path {
      fill: #000;
    }
    .md-icon {
      margin: 0 10px 0 0 !important;
    }
  }
}
</style>
